import { FetchMapSuccess } from 'actions/map/fetch';
import {
  AreaWithNestedJsonInfo,
  IMappableSetting,
  IMapState,
} from 'types/map';
import Area from 'mapping/Area';

export default function fetchMapSuccess(state: IMapState, { payload }: FetchMapSuccess) {
  const { currentArea, areas } = payload;

  const flattenedAreas = flattenAreas(areas);

  const flattenedStateAwareAreas = flattenedAreas
    .map(area => ({ ...area, ...area.jsonInfo }))
    .map(a => new Area(a).toStateAwareArea(flattenedAreas, state.setting! as IMappableSetting, currentArea));

  const currentAreaWithJsonInfo = new Area({ ...currentArea, ...(currentArea.jsonInfo ?? {}) })
    .toStateAwareArea(
      flattenedStateAwareAreas,
      state.setting! as IMappableSetting,
      currentArea,
    );

  return {
    ...state,
    currentArea: currentAreaWithJsonInfo,
    areas: flattenedStateAwareAreas,
    isFetching: false,
    shouldUpdate: false,
  };
}

function flattenAreas(areas: AreaWithNestedJsonInfo[]): AreaWithNestedJsonInfo[] {
  return areas.flatMap((a) => {
    if (a.childAreas && a.childAreas.length) {
      return [a, ...flattenAreas(a.childAreas)];
    }
    return [a];
  });
}
